/** @jsx jsx */
import { jsx } from '@emotion/core';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import React from 'react';
import YouTube from 'react-youtube';
import * as styles from './index.styles';

export default class Video extends SafePureComponent {
  state = { isVideoLoaded: false };

  render() {
    const { isVideoLoaded } = this.state;
    const { videoId } = this.props;
    const opts = {
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 1,
        mute: 1,
        rel: 0,
      },
    };

    return (
      <div css={[styles.videoHolder, isVideoLoaded && styles.showVideo]}>
        <span className="close_btnsec">
          <button onClick={this.props.toggleVideo}>
            <span>
              <i className="icon-closer" />
            </span>

            <span>Close</span>
          </button>
        </span>

        <div css={styles.videoIframeHolder}>
          {!isVideoLoaded && (
            <div css={styles.preloaderCss} className="preloaderCss">
              <div className="load-wraper">
                <div className="activity"></div>
              </div>
            </div>
          )}
          <div className="youtube-holder">
            <YouTube
              videoId={videoId}
              opts={opts}
              onReady={this._onReady}
              onEnd={this._onEnd}
            />
          </div>
        </div>
      </div>
    );
  }

  _onEnd = () => {
    // this.props.toggleVideo();
  };

  _onReady = event => {
    // access to player in all event handlers via event.target
    // event.target.pauseVideo();
    this.setState({ isVideoLoaded: true });
  };
}
